import { RewardListRuleState } from '@loyalty/shared-common/rule-api-client';
import { escape, getLocalizedProperty, htmlSanitize, uuid } from '@loyalty/shared-common';
import type { FrontendBurnRule, RewardsListBackendProps, RewardsListFrontendProps } from '../types';

export function serializeRewardsListComponentProps({
  state,
  options,
  context,
}: RewardsListBackendProps): RewardsListFrontendProps {
  const { rewardsRules, currencies, programId } = state;
  const { locale, formatNumber } = context.i18n;

  const burnRules: FrontendBurnRule[] = (rewardsRules?.rules || [])
    .filter(({ currency }) => !!currency)
    .map(({ id, reward, currency: ruleCurrency, state: rewardState, quantity }) => {
      const rewardPicture = getLocalizedProperty(reward, 'image', locale);
      const rewardDescription = htmlSanitize(getLocalizedProperty(reward, 'description', locale));
      const rewardName = getLocalizedProperty(reward, 'name', locale) || 'unknown reward';
      const currencyPicture = getLocalizedProperty(
        currencies.find(({ id: currencyId }) => currencyId === ruleCurrency?.id),
        'image',
        locale,
      );
      const currencyName = escape(
        getLocalizedProperty(
          currencies.find(({ id: currencyId }) => currencyId === ruleCurrency?.id),
          'name',
          locale,
        ),
      );
      const value = formatNumber(Math.abs(ruleCurrency?.value ?? 0));
      const rewardDetails = getLocalizedProperty(reward, 'details', locale);
      const detailsLabel = getLocalizedProperty(reward, 'detailsLabel', locale) || 'See more';
      const stock = formatNumber(quantity || 0);
      return {
        id: id || uuid(),
        rewardPicture,
        rewardName,
        rewardDescription,
        rewardDetails: rewardDetails ? htmlSanitize(rewardDetails) : undefined,
        detailsLabel,
        value,
        currencyName,
        currencyPicture,
        state: rewardState || RewardListRuleState.AVAILABLE,
        stock,
      };
    });

  return {
    id: options.id || options.attributes.id || uuid(),
    locale,
    attributes: options.attributes,
    i18nAttributes: options.i18nAttributes,
    programId,
    burnRules,
  };
}
